import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import MeasuredOrderVirtualList from '@/pages/orders/components/MeasuredOrderVirtualList';
import OrderCard from '@/shared-components/cards/components/OrderCard';

import SentOrderCard from './sent-order-card';

import './index.css';

export default function VirtualList({ fetchData, setFetchData, loadMoreData }) {
  const { state, stateHandler, cacheHandler } = useStateHandler();
  const navigate = useNavigate();
  const isGallery = state.user_session.user_type === "gallery";

  function onConfirmReception(orderId) {
    setFetchData({
      ...fetchData,
      totalDocs: fetchData.totalDocs - 1,
      data: fetchData.data.filter(order=>order._id !== orderId)
    });

    cacheHandler.triggerAction("CONFIRM_RECEPTION");

    setTimeout(() => {
      stateHandler.set("temporalPopup", {
        text: "The reception has been confirmed", 
      });
    }, 5000);
  }

  function onReportIssue(orderId, issueData) {
    setFetchData({
      ...fetchData,
      data: fetchData.data.map(order => {
        if(order._id === orderId) {
          return {
            ...order,
            order_issue: issueData
          };
        } else {
          return order;
        }
      })
    });

    stateHandler.set("temporalPopup", {
      text: "The issue has been reported to the gallery", 
    });
  }

  function onViewIssue(orderNumber) {
    navigate(`/order/${orderNumber}`, {
      state: { from: true, openIssueDetails: true },
    });
  }

  return (
    <MeasuredOrderVirtualList
      orders={fetchData.data}
      totalOrders={fetchData.totalDocs}
      loadMoreData={loadMoreData}
      defaultRowHeight={isGallery ? 244 : 294}
      renderOrder={(order) => (
        isGallery ? (
          <OrderCard orderData={order} navigateToView/>
        ) : (
          <SentOrderCard
            orderData={order}
            onConfirmReception={onConfirmReception}
            onReportIssue={onReportIssue}
            onViewIssue={() => onViewIssue(order.order_number)}
          />
        )
      )}
    />
  );
}
